// extracted by mini-css-extract-plugin
export default {"list":"Images_list__bzjeX","link":"Images_link__0YhxH"};